import React from "react";
import { X, Sparkles } from "lucide-react";

/**
 * Floating chat launcher pill. Collapsed state: a slim 40×40 gold circle
 * with the Sparkles glyph; label reveals on hover / focus-visible / open.
 * The previous separate "dismiss" X button has been retired — the panel's
 * own Close control covers that need and the collapsed pill no longer
 * eats adjacent screen real estate.
 */
export default function ChatLauncher({ open, engaged, onToggle, triggerRef }) {
  return (
    <button
      ref={triggerRef}
      onClick={onToggle}
      aria-label={open ? "Close JJ AI Assistant" : "Open JJ AI Assistant"}
      aria-expanded={open}
      aria-controls="chat-panel-title"
      data-testid="chat-toggle"
      className={`relative group inline-flex items-center gap-2 h-10 min-w-[40px] justify-center px-2.5 border transition-all duration-300 ${
        open
          ? "bg-[#151517] border-[#343437] text-[#A9A9A6]"
          : "bg-[#D8A936] border-[#D8A936] text-[#0B0B0C] hover:bg-transparent hover:text-[#D8A936]"
      }`}
    >
      {!open && !engaged && (
        <span aria-hidden className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-[#D8A936] chat-ping" />
      )}
      {open ? <X size={14} /> : <Sparkles size={14} />}
      <span
        className={`font-display text-[10px] tracking-[0.18em] uppercase whitespace-nowrap overflow-hidden transition-all duration-300 ${
          open
            ? "max-w-[5rem] opacity-100"
            : "max-w-0 opacity-0 group-hover:max-w-[5rem] group-hover:opacity-100 group-focus-visible:max-w-[5rem] group-focus-visible:opacity-100 sm:max-w-[5rem] sm:opacity-100"
        }`}
      >
        {open ? "Close" : "Ask JJ"}
      </span>
    </button>
  );
}
